import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-generic-image-carousel]',
};

class GenericImageCarousel extends HTMLElement {
  constructor() {
    super();

    this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);

    document.addEventListener('DOMContentLoaded', () => {
      this.initCarousels();
    });
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Navigation],
      freeMode: true,
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-generic-image-button-next',
        prevEl: '.swiper-generic-image-button-prev',
      },
    });
  }
}

customElements.define('generic-image-carousel', GenericImageCarousel);
